import { createAction } from "@reduxjs/toolkit";
import { Holder, PaginationOptions } from "../../interfaces";
import * as HolderActionTypes from "./types";

export const loadAllHolders = createAction<Partial<PaginationOptions>>(
  HolderActionTypes.fetch_paginated_holders_saga
);
export const loadHolderById = createAction<string>(
  HolderActionTypes.fetch_holder_by_id_saga
);
export const createHolder = createAction<Omit<Holder, "uid">>(
  HolderActionTypes.create_new_holder_saga
);
export const updateHolder = createAction<Holder>(
  HolderActionTypes.update_holder_saga
);
export const deleteHolderById = createAction<string>(
  HolderActionTypes.delete_holder_saga
);
export const resetPasswordById = createAction<string>(
  HolderActionTypes.reset_password_holder_saga
);
